import { z } from 'zod';
import { ObjectId as BSONObjectId } from 'bson';

export const objectId = z
    .custom<BSONObjectId>(
        value => {
            const s = getStringFromUnknown(value);
            return /^[0-9a-f]{24}$/.test(s);
        },
        { message: 'Invalid ObjectId' }
    )
    .transform((value: unknown) =>
        BSONObjectId.createFromHexString(getStringFromUnknown(value))
    );

export type ObjectId = z.infer<typeof objectId>;

function getStringFromUnknown(value: unknown): string {
    return typeof value === 'string'
        ? value
        : typeof value === 'object' &&
            value &&
            typeof value.toString === 'function'
          ? value.toString()
          : '';
}
